import initialStepValidation from "reducers/work-order/close-step-validation/initialStepValidation";
import { isFiberOrCommercial } from "utils/accountUtils";
import { isSkinnyInstallType } from "../../../utils/helper";
import { isSr } from "../../../utils/serviceTypeUtils";

export default (state, orderId) => {
  let currentValidation =
    state.getIn([
      "workOrderDetails",
      orderId,
      "orderClose",
      "details",
      "stepValidation",
    ]) || initialStepValidation;

  const orderStatus = state.getIn([
    "workOrderDetails",
    orderId,
    "orderClose",
    "details",
    "closeOrderRequest",
    "orderStatus",
  ]);

  const outletOptimizationStatus = state.getIn([
    "workOrderDetails",
    orderId,
    "orderClose",
    "details",
    "closeOrderRequest",
    "outletOptimizationStatus",
  ]);

  const isOutletOptimizationSet =
    outletOptimizationStatus != null && outletOptimizationStatus !== 3;

  const sac = state.getIn([
    "workOrderDetails",
    orderId,
    "customerDetails",
    "details",
    "signalAccessCode",
  ]);

  const customerType = state.getIn([
    "workOrderDetails",
    orderId,
    "customerDetails",
    "details",
    "customerType",
  ]);

  const serviceTypeId = state.getIn([
    "workOrderDetails",
    orderId,
    "schedulingSystemDetails",
    "details",
    "serviceOrderInfoV2",
    "serviceTypeId",
  ]);

  const isOutletOptimizationInactive =
    isFiberOrCommercial(sac, customerType) ||
    isSkinnyInstallType(serviceTypeId) ||
    isSr(serviceTypeId);

  if (!isOutletOptimizationInactive) {
    if (isOutletOptimizationSet || orderStatus === "NoAccess") {
      currentValidation = currentValidation.setIn(
        ["outletOptimization", "isValid"],
        true
      );
    } else {
      currentValidation = currentValidation.setIn(
        ["outletOptimization", "isValid"],
        false
      );
    }
  } else {
    currentValidation = currentValidation.setIn(
      ["outletOptimization", "isValid"],
      true
    );
  }

  return currentValidation;
};



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/outletOptimizationValidator.js